import { useContext } from "react";
import { CommonPropsContext } from "../contexts/CommonPropsContext";
import Delivered from "./Delivered";

const DeliveredOrderIndex = () => {
  const { dbConnections, loadingContext } =
    useContext(CommonPropsContext);

  return (
    <>
      {!loadingContext ? (
        <>
          {dbConnections.length > 0 &&
            // dbConnections.map((connection_key, index) => (
              <div>
                <Delivered connection_key={dbConnections[0]} />
              </div>
            // ))
            }
        </>
      ) : (
        <div id="loader"></div>
      )}
    </>
  );
};

export default DeliveredOrderIndex;
